module.exports = __webpack_public_path__ + "static/icons/personaje_computador_2.3fee82a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/general/personaje_computador_2.svg
// module id = 95or
// module chunks = 1